import { request } from 'utils/request';

type SubscriptionResponse = {
  id: number;
  interval: 'month' | 'year';
};

export const requestCurrentSubscription = () =>
  request.get<SubscriptionResponse>(
    `/api/internal/users/${sedition.currentUser.id}/subscription`,
  );
